import { render, staticRenderFns } from "./CompaniesApresentation.vue?vue&type=template&id=6cca9f54&scoped=true&"
import script from "./CompaniesApresentation.vue?vue&type=script&lang=js&"
export * from "./CompaniesApresentation.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesApresentation.vue?vue&type=style&index=0&id=6cca9f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca9f54",
  null
  
)

export default component.exports